import { createState, useState } from '@hookstate/core';
const initialState = {
    showConfirmPopUp: false,
    agentUserInfo: '',
    stateUpdated: false,
    userEvents: ''
};

const agentSaveAsDraftState = createState(initialState);

export const setAgentShowConfirmPopUp = (showConfirmPopUp) => {
    let state = {
        ...initialState,
        agentUserInfo: agentSaveAsDraftState.agentUserInfo.get()
    }
    agentSaveAsDraftState.set({
        ...state,
        showConfirmPopUp: showConfirmPopUp,
    });
    return;
};

export const setAgentUserInfo = (userInfo) => {
    let state = {
        ...initialState,
        stateUpdated: !agentSaveAsDraftState.stateUpdated,
        showConfirmPopUp: agentSaveAsDraftState.showConfirmPopUp.get()
    }
    agentSaveAsDraftState.set({
        ...state,
        agentUserInfo: userInfo,
    });
    return;
};

export const resetSaveAsDraftState = () => {
    agentSaveAsDraftState.set(initialState);
    return;
}

export const useAgentSaveAsDraftState = () => {
    return useState(agentSaveAsDraftState);
};


